import type { PageSEOKind } from "../types/core";

export type PageKindSeoRules = {
  /** Default robots when search indexing is allowed (staging flag off). */
  robots: string;
  openGraphType: string;
  twitterCard: "summary" | "summary_large_image";
  canonicalDropTrackingParams: boolean;
};

export const SEO_RULES_BY_KIND: Record<PageSEOKind, PageKindSeoRules> = {
  public_landing: {
    robots: "index,follow",
    openGraphType: "website",
    twitterCard: "summary_large_image",
    canonicalDropTrackingParams: true,
  },
  public_legal: {
    robots: "index,follow",
    openGraphType: "article",
    twitterCard: "summary_large_image",
    canonicalDropTrackingParams: true,
  },
  authenticated_tool: {
    robots: "noindex,nofollow",
    openGraphType: "website",
    twitterCard: "summary_large_image",
    canonicalDropTrackingParams: true,
  },
  auth_flow: {
    robots: "noindex,nofollow",
    openGraphType: "website",
    twitterCard: "summary_large_image",
    canonicalDropTrackingParams: true,
  },
  system_admin: {
    robots: "noindex,nofollow",
    openGraphType: "website",
    twitterCard: "summary_large_image",
    canonicalDropTrackingParams: true,
  },
};
